import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { CompanyData, LabelColors, PaymentDto, SubscriptionDto } from '../../../interfaces';
import { BehaviorSubject, distinctUntilChanged, map, Observable } from 'rxjs';
import { CompanyService } from '../../../services/company.service';
import { SubscriptionService } from '../../../services/subscription.service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BILLING_STATUS, LIQPAY_PAYMENT_STATUS } from 'src/app/shared/enums';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-subscription-history',
  templateUrl: './subscription-history.component.html',
  styleUrl: './subscription-history.component.scss'
})
export class SubscriptionHistoryComponent implements OnInit {
  @Input({ required: true }) company!: CompanyData;

  protected readonly BILLING_STATUS = BILLING_STATUS;
  protected currentSubscription$: BehaviorSubject<SubscriptionDto | null> = new BehaviorSubject<SubscriptionDto | null>(null);
  protected payments$: Observable<PaymentDto[] | null> = this.currentSubscription$.pipe(
    map((subscription) => subscription?.payments || null),
    distinctUntilChanged()
  );

  constructor(
    private companyService: CompanyService,
    private subscriptionService: SubscriptionService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private destroyRef: DestroyRef
  ) {
  }

  ngOnInit(): void {
    this.subscriptionService.getSubscriptionByCompanyId(this.company.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(this.currentSubscription$);
  }

  isReceiptAvailable(payment: PaymentDto): boolean {
    return payment.status === LIQPAY_PAYMENT_STATUS.SUCCESS
  }

  getLabel(payment: PaymentDto): LabelColors | undefined {
    const paymentStatusColorMap: Record<string, string> = {
      [LIQPAY_PAYMENT_STATUS.SUCCESS]: 'GREEN',
      [LIQPAY_PAYMENT_STATUS.SUBSCRIBED]: 'GREEN',
      [LIQPAY_PAYMENT_STATUS.FAILURE]: 'RED',
      [LIQPAY_PAYMENT_STATUS.ERROR]: 'RED',
      [LIQPAY_PAYMENT_STATUS.REVERSED]: 'GRAY',
      [LIQPAY_PAYMENT_STATUS.UNSUBSCRIBED]: 'GRAY'
    }

    return this.companyService.getLabelColorDataById(paymentStatusColorMap[payment.status] || 'BLUE');
  }

  sendReceiptEmail(payment: PaymentDto) {
    this.subscriptionService.sendReceiptRequest(payment.paymentId).subscribe({
      next: () => {
        const contactEmail = this.companyService.companyInfo$.getValue()?.contactEmployee?.email || '';
        const receiptSentMessage = this.translateService.instant('messages.receipt_sent', {contactEmail});
        this.toastrService.success(receiptSentMessage);
      }
    })
  }
}
